/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { DIALOGS_SELECTOR as f, DATA_DIALOGS_ID as i, ZINDEX_DIALOGS_STEP as s } from "./constants.mjs";
const A = (n, t, o) => {
  let e = n;
  if (t && t.defaultView) {
    const x = t.querySelectorAll(f);
    let l = !1;
    return x.forEach((d) => {
      const a = t.defaultView.getComputedStyle(d, null);
      if (d.getAttribute(i) !== o && a.zIndex !== null) {
        const I = parseInt(a.zIndex, 10);
        I >= e && (e = I, l = !0);
      }
    }), l ? e + s : e;
  }
  return e;
};
export {
  A as getMaxZIndex
};
